import { Component, OnInit } from '@angular/core';
import { ProductBrandService } from '../../../services/product-brand.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-brands',
  templateUrl: './list-product-brands.component.html',
  styleUrls: ['./list-product-brands.component.css'],
  providers:[ProductBrandService, ProductService]
})
export class ListProductBrandsComponent implements OnInit {

  productBrands:any = [];

  constructor(private productBrandService:ProductBrandService, private productService: ProductService) { }

  ngOnInit() {
    this.getProductBrands();
  }

  getProductBrands(){
    this.productBrandService.query({})
      .subscribe((productBrands) => {
        this.productBrands = productBrands;
        this.parseProducts();
      });
  }

  delete(productBrand){
    this.productService.query({brand:productBrand.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productBrandService.delete(productBrand.id)
        .subscribe((productBrands) => {
          this.getProductBrands()
        });
      }
    });
  }

  parseProducts(){
    this.productBrands.forEach(function (productBrand){
      productBrand.productTypes = "";
      if(productBrand.product_types.includes("1")){
        productBrand.productTypes += "Móviles y Tablets,";
      }
      if(productBrand.product_types.includes("2")){
        productBrand.productTypes += "Consolas,";
      }
      if(productBrand.product_types.includes("3")){
        productBrand.productTypes += "Artículos Varios,";
      }
      if(productBrand.product_types.includes("4")){
        productBrand.productTypes += "PC's-portátiles,";
      }
      productBrand.productTypes = productBrand.productTypes.substring(0,productBrand.productTypes.length - 1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-brands/list-product-brands/list-product-brands.component.ts